import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Layout from "../../components/Layout.js";

const VehicleAllocationGrid = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [gridData, setGridData] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelUnqId, setCancelUnqId] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [reasonList, setReasonList] = useState([]);
  const [filteredReasons, setFilteredReasons] = useState([]);
  const totalPages = Math.ceil(gridData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = gridData.slice(startIndex, startIndex + pageSize);

  /* ================= STYLES ================= */
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },

    modal: {
      width: "520px",
      background: "#fff",
      borderRadius: "6px",
      overflow: "hidden",
      boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    },

    header: {
      background: "#8B1E3F",
      color: "#fff",
      padding: "10px 15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: "bold",
    },

    body: {
      padding: "15px",
    },

    row: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: "10px",
      gap: "10px",
    },

    input: {
      padding: "6px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      width: "100%",
    },

    footer: {
      padding: "10px",
      display: "flex",
      gap: "10px",
      justifyContent: "flex-start",
    },

    saveBtn: {
      padding: "6px 14px",
      border: "1px solid #1976d2",
      background: "#fff",
      color: "#1976d2",
      cursor: "pointer",
    },

    closeBtn2: {
      padding: "6px 14px",
      background: "#f44336",
      color: "#fff",
      border: "none",
      cursor: "pointer",
    },

    closeBtn: {
      background: "transparent",
      border: "none",
      color: "#fff",
      cursor: "pointer",
      fontSize: "16px",
    },

    plusBtn: {
      padding: "6px 10px",
      border: "1px solid #333",
      background: "#fff",
      cursor: "pointer",
    },
  };

  const styles = {
    pageContainer: {
      width: "100%",
      minHeight: "100vh",
      backgroundColor: "#f4f6f8",
      padding: "10px",
      boxSizing: "border-box",
    },

    container: {
      width: "100%",
      backgroundColor: "#fff",
      padding: "15px",
      borderRadius: "6px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    },

    header: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "10px",
      marginBottom: "10px",
    },

    leftHeader: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "8px",
      flex: 1,
    },

    title: {
      fontSize: "1.1rem",
      fontWeight: "bold",
      whiteSpace: "nowrap",
    },

    searchInput: {
      minWidth: "70%",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "4px",
    },

    searchButton: {
      padding: "8px 14px",
      backgroundColor: "#2196F3",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },

    select: {
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
    },

    addButton: {
      padding: "8px 16px",
      backgroundColor: "#3a28a0",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },

    tableWrapper: {
      width: "100%",
      overflowX: "auto",
    },

    table: {
      width: "100%",
      minWidth: "1450px",
      borderCollapse: "collapse",
    },

    th: {
      backgroundColor: "#8B1E3F",
      color: "#fff",
      padding: "10px",
      border: "1px solid #ddd",
      fontSize: "0.85rem",
      whiteSpace: "nowrap",
      textAlign: "center",
    },

    td: {
      padding: "8px",
      border: "1px solid #ddd",
      fontSize: "0.85rem",
      whiteSpace: "nowrap",
      textAlign: "center",
    },

    actionBtn: (bg) => ({
      padding: "5px 10px",
      marginRight: "5px",
      backgroundColor: bg,
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "0.75rem",
    }),

    pagination: {
      marginTop: "12px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      fontSize: "0.9rem",
    },

    pageBtn: {
      padding: "6px 12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
    },
  };
  useEffect(() => {
    loadGrid();
  }, []);

  const loadGrid = async () => {
    try {
      const response = await apiFetch(
        "/api/vehicle/allocation-grid",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      setGridData(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Grid load error:", err);
      setGridData([]);
    }
  };

  const handleCancel = async (unqid) => {
    if (!window.confirm("Are you sure you want to cancel this allocation?")) return;
    try {
      const response = await apiFetch(
        "/api/vehicle/allocation-cancel",
        { method: "POST", body: JSON.stringify({ unqid }) },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Cancelled successfully");
        loadGrid();
      } else {
        alert(data.msg || "Cancel failed");
      }
    } catch (err) {
      console.error("Cancel error:", err);
      alert("Server error while cancelling");
    }
  };

  return (
    <Layout>
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          {/* ================= HEADER ================= */}
          <div style={styles.header}>
            <div style={styles.leftHeader}>
              <div style={styles.title}>VEHICLE ALLOCATION GRID</div>
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={styles.select}
              >
                {[10, 20, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    {size} / page
                  </option>
                ))}
              </select>
            </div>

            <button
              style={styles.addButton}
              onClick={() => navigate("/VehicleAllocation")}
            >
              Add New
            </button>
          </div>
          {/* ================= TABLE ================= */}
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Entry Date</th>
                  <th style={styles.th}>Receipt No</th>
                  <th style={styles.th}>Customer Name</th>
                  <th style={styles.th}>Model</th>
                  <th style={styles.th}>Variant</th>
                  <th style={styles.th}>Color</th>
                  <th style={styles.th}>Vin no</th>

                  <th style={styles.th}>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((row, index) => (
                    <tr key={row.va_12}>
                      <td style={styles.td}>{row.va_17}</td>
                      <td style={styles.td}>{row.va_18}</td>
                      <td style={styles.td}>{row.va_24}</td>
                      <td style={styles.td}>{row.va_26}</td>
                      <td style={styles.td}>{row.va_27}</td>
                      <td style={styles.td}>{row.va_28}</td>
                      <td style={styles.td}>{row.va_29}</td>

                      <td style={styles.td}>
                        <button
                          style={styles.actionBtn("#4CAF50")}
                          onClick={() =>
                            navigate("/VehicleAllocation", {
                              state: { unqid: row.va_12 },
                            })
                          }
                        >
                          View
                        </button>

                        <button
                          style={styles.actionBtn("#f44336")}
                          onClick={() => handleCancel(row.va_12)}
                        >
                          Cancel
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={12}
                      style={{ ...styles.td, textAlign: "center" }}
                    >
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          ={/* ================= PAGINATION ================= */}
          <div style={styles.pagination}>
            <button
              style={styles.pageBtn}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>

            <span>
              Page {currentPage} of {totalPages || 1}
            </span>

            <button
              style={styles.pageBtn}
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default VehicleAllocationGrid;
